import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import DashboardLayout from './../../components/Admin/DashboardLayout'
import { toast } from 'react-toastify'
import UserProfileService from './../../shared/services/UserProfile.service'
import PerformanceWidget from './components/PerformanceWidget/PerformanceWidget.component'
import DashboardMessages from './components/DashboardMessages/DashboardMessages.component'
import DashboardVideo from './components/DashboardVideo/DashboardVideo.component'
import AnnualTheme from './components/AnnualTheme/AnnualTheme.component'
import PushEnableCard from './../../components/push/PushEnableCard'
import { isWhiteLabel } from './../../shared/utilities/whiteLabel.function'

import './DashboardPage.scss'

class DashboardPage extends Component {
  state = {
    dependencies: {
      theme: false,
      video1: false,
      video2: false,
      messages: {
        alert: false,
        division: false,
        dashboard: false,
        leader: false,
      },
    },
  }

  componentDidMount() {}

  render() {
    toast.configure()

    // UAD-3667: white-label downline agents get an empty dashboard (USABG
    // widgets hidden); their entry point is the Contracting menu.
    if (isWhiteLabel()) {
      return (
        <DashboardLayout>
          <main id='DashboardPage' className='mainSection pt-4'></main>
        </DashboardLayout>
      )
    }

    return (
      <>
        <DashboardLayout>
          <main id='DashboardPage' className='mainSection pt-4'>
            <MDBContainer fluid>
              {/* Renders only when there is something the agent can act on —
                  never while impersonating, never once blocked, and not again
                  for two weeks after "Not now". */}
              <MDBRow>
                <MDBCol size='12'>
                  <PushEnableCard />
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol size='12' md='4' lg='5'>
                  <AnnualTheme
                    onSuccess={() => {
                      this.setState(prevState => ({
                        ...prevState,
                        dependencies: {
                          ...this.state.dependencies,
                          theme: true,
                        },
                      }))
                    }}
                    onError={() => {}}
                  />
                </MDBCol>
                <MDBCol size='12' md='8' lg='7'>
                  <DashboardMessages
                    activeDivisionId={UserProfileService.get('u_devision')}
                    onSuccess={m => {
                      this.setState(prevState => ({
                        ...prevState,
                        dependencies: {
                          ...this.state.dependencies,
                          messages: {
                            ...this.state.dependencies.messages,
                            ...m,
                          },
                        },
                      }))
                    }}
                    onError={() => {}}
                  />
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol size='12' md='6'>
                  <DashboardVideo
                    videoId={16}
                    onSuccess={() => {
                      this.setState(prevState => ({
                        ...prevState,
                        dependencies: {
                          ...this.state.dependencies,
                          video1: true,
                        },
                      }))
                    }}
                    onError={() => {}}
                  />
                </MDBCol>
                <MDBCol size='12' md='6'>
                  <DashboardVideo
                    videoId={41}
                    onSuccess={() => {
                      this.setState(prevState => ({
                        ...prevState,
                        dependencies: {
                          ...this.state.dependencies,
                          video2: true,
                        },
                      }))
                    }}
                    onError={() => {}}
                  />
                </MDBCol>
              </MDBRow>
            </MDBContainer>

            <MDBContainer fluid className='mt-3'>
              <PerformanceWidget />
            </MDBContainer>
          </main>
        </DashboardLayout>
      </>
    )
  }
}

export default DashboardPage
